import React from 'react';
import Head from 'next/head';

import styles from './Error500.module.scss';

const Error500 = () => {
    return (
        <div className={styles.className}>
            <Head>
                <title>Oops - Wedding Spot</title>
            </Head>
            <div className={styles.messageWrapper}>
                <div className={styles.messageContainer}>
                    <h3 className={styles.headline}>Oops!</h3>
                    <p>
                        We're down for a bit but the team is working hard to fix this! Please check back in a few minutes. If this continues
                        to be an issue, please <a href='mailto:support@wedding-spot.com'>let us know </a>
                        how you landed on this page and we will look into it.
                    </p>
                    <p>
                        <a href='/wedding-venues/' className={styles.button}>
                            Find a venue
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Error500;
